import { v4 as uuidv4 } from 'uuid';

async function refreshSubscriptions() {
    // Reset lists before re-fetching so we don't append duplicates
    this.subscriptions = [];
    this.inactiveSubscriptions = [];
    this.connectedSchedules = {};
    this.subscriptionDetails = {};
    this.page = { number: 1, limit: 10 };

    await this.getSubscriptions();
}

export default refreshSubscriptions;
